<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">A<span class="small">CKNOWLEDGEMENTS</span></p>
<p class="noindent">This has been a passion of mine on and off for over twenty-two years. During the past several years, there have been a number of people who have helped me in one way or another, and I am extremely grateful. First and foremost, I must thank Donna Tucker-Mooney and Christine Hopkins. I am also in debt to everyone at the Foster Preservation Society for the immeasurable assistance, stories and pictures of Foster. Thank you to the Foster Library, Foster Town Hall, Burrillville Historical Preservation Society, Burrillville Town Hall, Carl Johnson, Kent Spotswood, Keith and Sandra Johnson, Kevin Fay, Robert Vespia, John Boitano, Tom and Susan Wood and Andrew Lake for his continuing research. Thank you to Brian Harnois, Christian White and Jason Mayoh for bringing the story back to the forefront with Rhode Island PBS. Thanks also to the Observer Publications/<i>Valley Breeze</i> weekly newspaper; the Killingly Historical Society; R.J. Himes for his segment on Ramtail with WJAR’s <i>Freaky Friday</i>; Dick Simons; the Scituate Town Hall; the Greenville Public Library; North Scituate Library; and musician, songwriter and historian Mike Carroll and his wife, Kathy. Thank you to the wonderful people of Foster and all others who wished to remain anonymous but were extremely valuable in the writing of this book.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?2a425c94